import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import Dogs from './pages/Dogs/Dogs';
import DogDetails from './pages/Dogs/DogDetails';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';
import Donate from './pages/Donate/Donate';
import ProiectMiauCasa from './pages/ProiectMiauCasa';
import Faq from './pages/Faq/Faq';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions/TermsConditions';
import CookiePolicy from './pages/CookiePolicy/CookiePolicy';
import AccessibilityStatement from './pages/AccessibilityStatement/AccessibilityStatement';
import { NotificationProvider } from './contexts/NotificationContext';
import { AnimalsProvider } from './contexts/AnimalsContext';
import { SystemSettingsProvider } from './contexts/SystemSettingsContext';

function App() {
  return (
    <SystemSettingsProvider>
      <AnimalsProvider>
        <NotificationProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="caini" element={<Dogs />} />
              <Route path="caini/:id" element={<DogDetails />} />
              <Route path="despre-noi" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="doneaza" element={<Donate />} />
              <Route path="proiect-miau-casa" element={<ProiectMiauCasa />} />
              <Route path="intrebari" element={<Faq />} />
              <Route path="politica-confidentialitate" element={<PrivacyPolicy />} />
              <Route path="politica-de-confidentialitate" element={<PrivacyPolicy />} />
              <Route path="termeni-conditii" element={<TermsConditions />} />
              <Route path="termeni-si-conditii" element={<TermsConditions />} />
              <Route path="politica-cookie" element={<CookiePolicy />} />
              <Route path="accesibilitate" element={<AccessibilityStatement />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </NotificationProvider>
      </AnimalsProvider>
    </SystemSettingsProvider>
  );
}

export default App;
